import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export function BuildingPlanRestriction({
  reason,
  needsBillingSetup,
  onSetup,
}: {
  reason?: string;
  needsBillingSetup?: boolean;
  onSetup?: () => void;
}) {
  const { t } = useLanguage();
  if (!reason) return null;
  return (
    <div className="space-y-2">
      <p role="status" className="text-sm text-destructive">
        {reason}
      </p>
      {needsBillingSetup && (
        <Button type="button" variant="outline" onClick={onSetup} asChild={!onSetup}>
          {onSetup ? t.billing.nav.details : <a href="/billing/details">{t.billing.nav.details}</a>}
        </Button>
      )}
    </div>
  );
}
